import aktienModul from 'modules/aktien';
import redditModul from 'modules/reddit';
import analyseModul from 'modules/analyse';
import todoModul from 'modules/todo';
import wissenModul from 'modules/wissen';
import identitaetenModul from 'modules/identitaeten';
import finanzenModul from 'modules/finanzen';

/**
 * Zentrale Modul-Registry des Portals.
 *
 * ▶ NEUES MODUL HINZUFÜGEN (2 Schritte):
 *   1. Unter src/modules/<modul>/ das Modul anlegen (index.js exportiert die
 *      Modul-Definition: id, name, description, path, icon, gradient, status,
 *      reducers, routes, optional portalWidgets).
 *   2. Das Modul hier importieren und in MODULES eintragen.
 *
 * App (Routen), Store (Reducer) und Übersichtsseite (Kreise, Widgets) speisen
 * sich ausschließlich aus dieser Liste – Module exportieren nur ihre
 * Definition und ggf. eine kleine öffentliche API an andere Module.
 */
export const MODULES = Object.freeze([
  aktienModul,
  redditModul,
  analyseModul,
  todoModul,
  wissenModul,
  identitaetenModul,
  finanzenModul,
]);

/** Projekt-Metadaten für Übersichtsseite und projects-Slice. */
export const MODULE_PROJECTS = Object.freeze(
  MODULES.map(({ id, name, description, path, icon, gradient, status, secured }) => ({
    id,
    name,
    description,
    path,
    icon,
    gradient,
    status,
    // Gesicherte Bereiche erscheinen nur im entsperrten "gesicherten Modus".
    secured: Boolean(secured),
  }))
);
